// Fixed display order for diet meal types.
export const MEALPERIODS = [
  'Pre-Breakfast',
  'Breakfast',
  'Mid-Morning Snack',
  'Lunch',
  'Snacks',
  'Dinner',
  'Bedtime',
  'Pre-Workout',
  'Post-Workout',
];
